import React, { useEffect, useState } from 'react';
import { ImageOff } from 'lucide-react';
import api from '../../services/api';

interface SecureImageProps {
  path: string;
  alt: string;
  className?: string;
}

export const SecureImage: React.FC<SecureImageProps> = ({ path, alt, className = '' }) => {
  const [src, setSrc] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let objectUrl: string | null = null;
    let cancelled = false;

    setFailed(false);
    setSrc(null);

    api
      .get(path, { responseType: 'blob' })
      .then((res) => {
        if (cancelled) return;
        objectUrl = URL.createObjectURL(res.data);
        setSrc(objectUrl);
      })
      .catch(() => {
        if (!cancelled) setFailed(true);
      });

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [path]);

  if (failed) {
    return (
      <div className={`flex items-center justify-center bg-surface-var text-onSurface-mute ${className}`}>
        <ImageOff className="w-6 h-6" />
      </div>
    );
  }

  if (!src) {
    return <div className={`skeleton ${className}`} />;
  }

  return <img src={src} alt={alt} className={className} />;
};
